import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import { forwardRef } from "react";

import type { ParticipantRow } from "../data/types";

interface UserDialogProps {
  rows?: ParticipantRow[];
  onSetUser: (user: string) => void;
}

const GUEST_USER = "GUEST";

export const UserDialog = forwardRef<HTMLDivElement, UserDialogProps>(
  function UserDialog({ rows = [], onSetUser }, ref): JSX.Element {
    const names = [
      ...rows
        .map((row) => row.name)
        .filter((name): name is string => Boolean(name)),
      GUEST_USER,
    ];

    return (
      <Box
        ref={ref}
        tabIndex={-1}
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          minHeight: "100vh",
          p: 2,
        }}
      >
        <Paper elevation={3} sx={{ minHeight: 200, minWidth: 220, p: 2 }}>
          <Typography component="h1" sx={{ fontWeight: 700 }}>
            Select user
          </Typography>
          <Stack
            direction="row"
            flexWrap="wrap"
            gap={1.25}
            sx={{ maxHeight: 500, maxWidth: 420, overflow: "auto", py: 2.5 }}
          >
            {names.map((name) => (
              <Chip key={name} label={name} onClick={() => onSetUser(name)} />
            ))}
          </Stack>
        </Paper>
      </Box>
    );
  },
);
